import { Routes } from '@angular/router';
import { AppLayoutComponent } from './layout/app-layout/app-layout.component';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
    {
        path: 'login',
        loadComponent: () => import('./features/auth/login/login.component').then(m => m.LoginComponent)
    },
    {
        path: '',
        component: AppLayoutComponent,
        canActivate: [authGuard],
        children: [
            {
                path: 'empresas',
                loadComponent: () => import('./features/empresa/empresa-list/empresa-list.component').then(m => m.EmpresaListComponent)
            },
            {
                path: 'comprobantes',
                loadComponent: () => import('./features/comprobante/comprobante-list/comprobante-list.component').then(m => m.ComprobanteListComponent)
            },
            {
                path: 'dashboard',
                loadComponent: () => import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent)
            },
            {
                path: 'usuarios',
                loadComponent: () => import('./features/usuario/usuario-list/usuario-list.component').then(m => m.UsuarioListComponent)
            },
            {
                path: 'correlativos',
                loadComponent: () => import('./features/correlativos/correlativos.component').then(m => m.CorrelativosComponent)
            },
            {
                path: '',
                redirectTo: 'dashboard',
                pathMatch: 'full'
            }
        ]
    }
];

